import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import CreateChallengeModal from '../components/challenges/CreateChallengeModal';
import { TrophyIcon, CalendarIcon, CheckCircleIcon, XIcon, PlusIcon } from 'lucide-react';
interface Challenge {
  id: number;
  title: string;
  description: string;
  emoji: string;
  duration: string;
  reward: number;
  status: 'active' | 'available';
  progress?: {
    current: number;
    total: number;
  };
}
const challenges: Challenge[] = [
// Active Challenges
{
  id: 1,
  title: 'Settimana in Bici',
  description: 'Vai al lavoro in bici per 5 giorni questa settimana',
  emoji: '🚲',
  duration: '7 giorni',
  reward: 250,
  status: 'active',
  progress: {
    current: 2,
    total: 5
  }
}, {
  id: 2,
  title: 'Carpooling Champion',
  description: "Condividi l'auto almeno 3 volte questa settimana",
  emoji: '🚙',
  duration: '7 giorni',
  reward: 150,
  status: 'active',
  progress: {
    current: 1,
    total: 3
  }
},
// Available Challenges
{
  id: 3,
  title: 'Zero Plastica',
  description: 'Non usare plastica monouso per 7 giorni consecutivi',
  emoji: '♻️',
  duration: '7 giorni',
  reward: 200,
  status: 'available'
}, {
  id: 4,
  title: 'Camminatore Urbano',
  description: 'Cammina almeno 10.000 passi al giorno per una settimana',
  emoji: '🚶',
  duration: '7 giorni',
  reward: 180,
  status: 'available'
}, {
  id: 5,
  title: 'Settimana Vegetariana',
  description: 'Mangia solo pasti vegetariani per 7 giorni',
  emoji: '🥗',
  duration: '7 giorni',
  reward: 220,
  status: 'available'
}, {
  id: 6,
  title: 'Risparmio Energetico',
  description: 'Riduci il consumo energetico del 20% questa settimana',
  emoji: '💡',
  duration: '7 giorni',
  reward: 160,
  status: 'available'
}];
const ChallengesPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState<'all' | 'active' | 'available'>('all');
  const activeChallenges = challenges.filter(c => c.status === 'active');
  const availableChallenges = challenges.filter(c => c.status === 'available');
  const filteredChallenges = activeFilter === 'all' ? challenges : activeFilter === 'active' ? activeChallenges : availableChallenges;
  return <div className="flex h-screen bg-gray-50" data-id="element-2110">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2111">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2112"></div>
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2113">
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2114">
            <Sidebar activePage="community" data-id="element-2115" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2116">
        <Sidebar activePage="community" data-id="element-2117" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2118">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2119" />

        <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-gray-50" data-id="element-2120">
          <div className="max-w-7xl mx-auto" data-id="element-2121">
            {/* Header */}
            <div className="mb-8" data-id="element-2122">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-2" data-id="element-2123">
                <div className="flex items-center gap-3" data-id="element-2124">
                  <TrophyIcon size={32} className="text-green-600" strokeWidth={1.5} data-id="element-2125" />
                  <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2126">
                    Challenges
                  </h1>
                </div>
                <button onClick={() => setIsCreateModalOpen(true)} className="flex items-center justify-center px-4 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors font-medium text-sm whitespace-nowrap" data-id="element-2127">
                  <PlusIcon size={18} className="mr-2" strokeWidth={2} data-id="element-2128" />
                  Proponi Challenge
                </button>
              </div>
              <p className="text-sm text-gray-600 font-normal" data-id="element-2129">
                Partecipa alle sfide della community, guadagna Star e fai la
                differenza
              </p>
            </div>

            {/* Filters */}
            <div className="flex gap-2 mb-6 overflow-x-auto pb-2" data-id="element-2130">
              <button onClick={() => setActiveFilter('all')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${activeFilter === 'all' ? 'bg-green-600 text-white' : 'bg-white text-gray-700 border border-gray-200 hover:border-green-600'}`} data-id="element-2131">
                Tutte
              </button>
              <button onClick={() => setActiveFilter('active')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${activeFilter === 'active' ? 'bg-green-600 text-white' : 'bg-white text-gray-700 border border-gray-200 hover:border-green-600'}`} data-id="element-2132">
                Attive
              </button>
              <button onClick={() => setActiveFilter('available')} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${activeFilter === 'available' ? 'bg-green-600 text-white' : 'bg-white text-gray-700 border border-gray-200 hover:border-green-600'}`} data-id="element-2133">
                Disponibili
              </button>
            </div>

            {/* Active Challenges Section */}
            {(activeFilter === 'all' || activeFilter === 'active') && activeChallenges.length > 0 && <div className="mb-8" data-id="element-2134">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2135">
                    Attive
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2136">
                    {activeChallenges.map(challenge => <ChallengeCard key={challenge.id} challenge={challenge} data-id="element-2137" />)}
                  </div>
                </div>}

            {/* Available Challenges Section */}
            {(activeFilter === 'all' || activeFilter === 'available') && availableChallenges.length > 0 && <div data-id="element-2138">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2139">
                    Disponibili
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2140">
                    {availableChallenges.map(challenge => <ChallengeCard key={challenge.id} challenge={challenge} data-id="element-2141" />)}
                  </div>
                </div>}

            {filteredChallenges.length === 0 && <div className="text-center py-12" data-id="element-2142">
                <TrophyIcon size={48} className="text-gray-300 mx-auto mb-4" strokeWidth={1.5} data-id="element-2143" />
                <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-2144">
                  Nessuna challenge trovata
                </h3>
                <p className="text-sm text-gray-600 font-normal" data-id="element-2145">
                  Prova a cambiare i filtri
                </p>
              </div>}
          </div>
        </main>
      </div>
    </div>;
};
interface ChallengeCardProps {
  challenge: Challenge;
}
const ChallengeCard: React.FC<ChallengeCardProps> = ({
  challenge
}) => {
  const progressPercentage = challenge.progress ? challenge.progress.current / challenge.progress.total * 100 : 0;
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:border-green-600 transition-all hover:shadow-sm" data-id="element-2146">
      <div className="p-5" data-id="element-2147">
        {/* Emoji and Status Badge */}
        <div className="flex items-start justify-between mb-3" data-id="element-2148">
          <div className="text-4xl" data-id="element-2149">{challenge.emoji}</div>
          {challenge.status === 'active' && <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700 border border-green-200" data-id="element-2150">
              Attiva
            </span>}
        </div>

        {/* Title and Description */}
        <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2151">
          {challenge.title}
        </h3>
        <p className="text-sm text-gray-600 font-normal mb-4 leading-relaxed" data-id="element-2152">
          {challenge.description}
        </p>

        {/* Progress Bar (only for active challenges) */}
        {challenge.progress && <div className="mb-4" data-id="element-2153">
            <div className="flex justify-between text-xs text-gray-600 font-normal mb-2" data-id="element-2154">
              <span data-id="element-2155">Progresso</span>
              <span className="font-medium text-gray-900" data-id="element-2156">
                {challenge.progress.current}/{challenge.progress.total}
              </span>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-2157">
              <div className="bg-green-600 h-full rounded-full transition-all duration-500" style={{
            width: `${progressPercentage}%`
          }} data-id="element-2158"></div>
            </div>
          </div>}

        {/* Duration and Reward */}
        <div className="flex items-center justify-between text-sm mb-4 pb-4 border-b border-gray-100" data-id="element-2159">
          <div className="flex items-center text-gray-600 font-normal" data-id="element-2160">
            <CalendarIcon size={14} className="mr-1.5" strokeWidth={1.5} data-id="element-2161" />
            <span data-id="element-2162">{challenge.duration}</span>
          </div>
          <div className="flex items-center text-yellow-600 font-medium" data-id="element-2163">
            <span className="text-lg mr-1" data-id="element-2164">⭐</span>
            <span data-id="element-2165">+{challenge.reward}</span>
          </div>
        </div>

        {/* Action Button */}
        <button className={`w-full flex items-center justify-center py-2.5 rounded-lg text-sm font-medium transition-colors ${challenge.status === 'active' ? 'bg-gray-100 text-gray-700 hover:bg-gray-200' : 'bg-green-600 text-white hover:bg-green-700'}`} data-id="element-2166">
          {challenge.status === 'active' ? <>
              <CheckCircleIcon size={16} className="mr-2" strokeWidth={2} data-id="element-2167" />
              In corso
            </> : 'Accetta Sfida'}
        </button>
      </div>
    </div>;
};
export default ChallengesPage;